import { render, staticRenderFns } from "./StudentMd.vue?vue&type=template&id=7a6ec651"
import script from "./StudentMd.vue?vue&type=script&lang=ts"
export * from "./StudentMd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports